import { render, staticRenderFns } from "./CobranzasPorAgencia.vue?vue&type=template&id=649fcc62&scoped=true"
import script from "./CobranzasPorAgencia.vue?vue&type=script&lang=js"
export * from "./CobranzasPorAgencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649fcc62",
  null
  
)

export default component.exports